'use strict';

/* global store */

export default function(element) {
  function isColorAnOption() {
    return $('.color-selector__color-check').length > 1;
  }

  $('body').on('click', '.product-tile__colors .color-selector__list-item', function() {
    if (!isColorAnOption()) {
      return;
    }

    var $inputClicked = $(this).find('.color-selector__color-check');
    var $target = $(this).find('.color-selector__color-decorator');
    var $oldSelection = $(this)
      .closest('.color-selector')
      .find('.color-selector__color-decorator');
    var colorAlreadySelected = false;

    if ($target.hasClass('active')) {
      colorAlreadySelected = true;
    }

    if (!colorAlreadySelected) {
      $oldSelection.removeClass('active');
      $target.addClass('active');
      var imageurl = $inputClicked.attr('data-url');
      var dataid = $inputClicked.attr('data-id').toString();
      var imageid = '#product-tile-sku-' + dataid + ' img';

      var oldAssetId = $(imageid).attr('data-asset-id');
      var oldSet = $(imageid)
        .attr('srcset')
        .toString();
      var oldSrc = $(imageid)
        .attr('src')
        .toString();
      var start = imageurl.lastIndexOf('/') + 1;
      var end = imageurl.indexOf('?');
      var newAssetId = imageurl.slice(start, end);
      var myRegex = new RegExp(oldAssetId, 'g');
      var newSet = oldSet.replace(myRegex, newAssetId);
      var newSrc = oldSrc.replace(myRegex, newAssetId);

      $(imageid).attr('data-asset-id', newAssetId);
      $(imageid).attr('data-srcset', newSet);
      $(imageid).attr('srcset', newSet);
      $(imageid).attr('data-src', newSrc);
      $(imageid).attr('src', newSrc);
      $inputClicked.attr('checked', true);
    }
  });

  $('body').on('mousedown', '.product-tile a', function() {
    var $parentContainer = $(this).closest('.product-tile');
    var $activeSwatch = $parentContainer.find('.color-selector__color-decorator.active');
    if ($activeSwatch.length < 1) {
      $activeSwatch = $parentContainer.find('.color-selector__color-decorator:first');
    }
    var $checkBoxSwatch = $activeSwatch.closest('.color-selector__list-item').find('.color-selector__color-check');
    var colorValue = $checkBoxSwatch.data('color');

    var originalLink = $(this).attr('href');
    if (typeof colorValue != 'undefined' && originalLink != 'undefined') {
      var newLink = updateUrlParameter(originalLink, 'colorCode', colorValue);
      $(this).attr('href', newLink);
    }
  });

  function updateUrlParameter(uri, key, value) {
    // remove the hash part before operating on the uri
    var i = uri.indexOf('#');
    var hash = i === -1 ? '' : uri.substr(i);
    uri = i === -1 ? uri : uri.substr(0, i);

    var re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
    var separator = uri.indexOf('?') !== -1 ? '&' : '?';

    if (!value) {
      // remove key-value pair if value is empty
      uri = uri.replace(new RegExp('([?&]?)' + key + '=[^&]*', 'i'), '');
      if (uri.slice(-1) === '?') {
        uri = uri.slice(0, -1);
      }
      // replace first occurrence of & by ? if no ? is present
      if (uri.indexOf('?') === -1) uri = uri.replace(/&/, '?');
    } else if (uri.match(re)) {
      uri = uri.replace(re, '$1' + key + '=' + value + '$2');
    } else {
      uri = uri + separator + key + '=' + value;
    }
    return uri + hash;
  }

  // register the newest PLP address only if it has products with compare links
  if ($('.product-tile__compare').length && $('.product-list').length) {
    // Set the latest PLP URL in Vuex
    let lastPlpUrl = window.location.pathname;
    if (window.store) {
      store.commit('storage/setLastPlp', lastPlpUrl);
    }

    // Keeping the "legacy" method of directly setting local storage in case it's used anywhere
    lastPlpUrl = JSON.stringify(window.location.pathname);
    localStorage.setItem('latest_plp_url', lastPlpUrl);
  }

  // Trigger initial resize
  $(element).trigger('resize');
}
